import { z } from 'zod';
import { Combinator } from 'modules/queryBuilder/types';
import { useSegmentationRequirementSchema } from './useSegmentationRequirementSchema';

export const useSegmentationCriteriaSchema = () => {
  const segmentationRequirementSchema = useSegmentationRequirementSchema();
  return z.object({
    combinator: z.nativeEnum(Combinator),
    searchQueries: z.array(segmentationRequirementSchema),
  });
};
